// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/drag/style/index.less
// module id = 501
// module chunks = 0